<template>
    <div class="my-benefit-container" @click="$emit('select', benefit)">
        <div class="benefit-card">
            <div class="benefit-item-image" :class="{ 'locked': isLocked }">
                <span 
                    class="benefit-item-icon-mask"
                    :class="{ 'locked': isLocked }"
                    :style="{ WebkitMaskImage: `url(${benefitIcon})`, maskImage: `url(${benefitIcon})` }"
                    :aria-label="isLocked ? 'Locked benefit icon' : 'Verified benefit icon'"
                ></span>
            </div>
            <div class="benefit-card-title">
                <span class="benefit-title">{{ benefitTitle }}</span>
                <span class="benefit-location">{{ benefitLocation }}</span>
            </div>
        </div>
        <img src="/img/member-icon/arrow-right.svg" alt="">
    </div>
</template>

<script>
export default {
    name: 'MyBenefit',
    emits: ['select'],
    props: {
        benefit: {
            type: Object,
            required: true,
            default: () => ({})
        },
        isLocked: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        benefitTitle() {
            return this.benefit?.name || 'Member Benefit';
        },
        benefitLocation() {
            return this.benefit?.merchant?.name
                || this.benefit?.branch?.name
                || this.benefit?.corporate?.name
                || '—';
        },
        benefitIcon() {
            return this.isLocked 
                ? '/img/member-icon/locked-icon.svg' 
                : '/img/member-icon/checklist.svg';
        }
    }
}
</script>

<style scoped>

.benefit-item-image {
    width: 44px;
    min-width: 44px;
    height: 44px;
    min-height: 44px;
    background-color: white;
    border-radius: 50%;
    border: 1px solid #E1E4EA;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
}

.benefit-item-image.locked {
    background-color: #F5F5F5;
    border-color: #D1D5DB;
}

.benefit-item-icon-mask {
    display: inline-block;
    width: 60%;
    height: 60%;
    background-color: var(--primary-color, #00AA00);
    -webkit-mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
}

.benefit-item-icon-mask.locked {
    background-color: var(--primary-color, #F93E3E);
}

.my-benefit-container {
    display: flex;
    width: 100%;
    gap: 16px;
    padding: 16px;
    background-color: white;
    border-radius: 12px;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border: 1px solid #e1e4ea79;
}

.my-benefit-container img {
    width: 24px;
    height: 24px;
}

.benefit-card {
    display: flex;
    align-items: center;
    gap: 12px;
}

.benefit-card-title {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.benefit-title {
    font-size: 12px;
    font-weight: 520;
    color: black;
}

.benefit-location {
    font-size: 10px;
    color: #717784;
}
</style>